import {MULTI_FREEZE} from 'constants/track-types.js';
import {TRACK} from 'constants/object-types.js';
import React from 'react';
import {MULTI_SYNTH, SAMPLED_INSTRUMENT} from 'constants/instrument-types.js';
import MultiFreezeThumbnails from 'components/freeze/MultiFreezeThumbnails.js';

const DRUM_TAGS = new Set(['clap', 'tom', 'toms', 'clave', 'perc', 'snare', 'kick', 'hi-hat', 'rim', 'side-stick', 'breaks', 'sub', 'ride',]);

export const getTrackShortName = (track, sample) => {
    if (!track || track.subSequence === track) {
        return '';
    }

    if (!track.getObjectType || track.getObjectType() !== TRACK) {
        return '';
    }
    
    let innerText = '';
    if (track && track.tracks && track.tracks[0]) {
        if (track.tracks[0].track) {
            track = track.tracks[0].track;
        }
    }
    let _sample = sample || track.sample;
    if (_sample && _sample.tags) {
        innerText = _sample.tags.find(tag => DRUM_TAGS.has(tag));
        if (!innerText) {
            innerText = _sample.tags[0];
        }
    }
    if (track && track.getInstrumentType() == MULTI_SYNTH) {
        innerText = 'Synth';
    }

    if (track && track.getTrackType() === MULTI_FREEZE) {
        innerText = (<MultiFreezeThumbnails track={track}/>);
    }

    if (track && track.getInstrumentType() === SAMPLED_INSTRUMENT) {
        let samples = track.instrument.getSamples();
        if (samples[0] && samples[0].tags) {
            innerText = samples[0].tags.find(tag => DRUM_TAGS.has(tag));
        }
    }

    return innerText;
};
